import anpMetadata from './data/metadata.json';
import type { AnpCombustiveisDataVersion } from './types.js';

export const ANP_COMBUSTIVEIS_DATA_VERSION: AnpCombustiveisDataVersion =
  anpMetadata as AnpCombustiveisDataVersion;
